var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c(_vm.key,{tag:"component",attrs:{"source":_vm.source,"is-input-method-selectable":_vm.isInputMethodSelectable,"is-image-registration-enable":_vm.isImageRegistrationEnable,"disabledDescription":"このオブジェクトは変更できません。"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }